<div class="stepper-wrapper">
  <small class="debug">{{me}}</small>
  <div class="step-header">
    @if (selectedStep == 0) {
      <span>{{'general.properties' | transloco}}</span>
    }
    @if (selectedStep == 1) {
      <span>{{'general.type' | transloco}}</span>
    }
    @if (selectedStep == 2) {
      <span>{{'general.dimensions' | transloco}}</span>
    }
    @if (selectedStep == 3) {
      <span>{{'general.content' | transloco}}</span>
    }
    @if (selectedStep == 4) {
      <span>{{'general.player' | transloco}}</span>
    }
    @if (selectedStep == 5) {
      <span>{{'general.animation' | transloco}}</span>
    }
    @if (selectedStep == 6) {
      <span>{{'general.complete' | transloco}}</span>
    }
  </div>
  <div class="stepper-btn">
    @if (selectedStep != 0) {
      <button mat-raised-button color="warn" (click)="stepper.previous()">{{'general.back' | transloco}}</button>
    }
    @if (selectedStep != 6) {
      <button mat-raised-button color="warn" (click)="stepper.next()">{{'general.next' | transloco}}</button>
    }
  </div>
  <mat-horizontal-stepper linear #stepper (selectionChange)="onStepChange($event)">
    <mat-step [stepControl]="propertyFormGroup">
      <ng-template matStepLabel>{{'general.properties' | transloco}}</ng-template>
      <form [formGroup]="propertyFormGroup">
        <div fxFlex fxLayoutAlign="space-around center" class="step-body-wrapper flex-lt-sm-col">
          <mat-form-field>
            <mat-label>{{'general.sceneName' | transloco}}</mat-label>
            <input autocomplete="off" inputrestriction="basic1" matInput formControlName="scene_name" placeholder="{{'general.sceneName' | transloco}}" required>
          </mat-form-field>
          <app-category-filter [categories]="categories" (updateCategory)="changeSceneCategory($event);"></app-category-filter>
        </div>
      </form>
    </mat-step>
    <mat-step [completed]="isStep2Completed">
      <ng-template matStepLabel>{{'general.type' | transloco}}</ng-template>
      <div fxFlex fxLayoutAlign="space-around center" class="step-body-wrapper flex-lt-md-col">
        <mat-card [ngClass]="{'active': sceneType == 'blank'}" (click)="setSceneType('blank');">
          <mat-card-title>
            <span>{{'general.blankScene' | transloco}}</span>
          </mat-card-title>
          <div class="wizard-card-body" fxLayoutAlign="space-around center" fxLayout="column">
            <mat-icon style="font-size: 50px; width: 50px; height: 50px;">crop_din</mat-icon>
            <div class="select-playlist">
              <div style="margin-bottom: 5px;">
                <mat-checkbox [checked]="playerAssignable" [(ngModel)]="playerAssignable">{{'general.playerAssignable' | transloco}}</mat-checkbox>
              </div>
              <!--                            <mat-form-field *ngIf="playerAssignable">-->
              <!--                                <mat-label>{{'general.enableScheduler' | transloco}}</mat-label>-->
              <!--                                <mat-select [(value)]="sceneSchedule">-->
              <!--                                    <mat-option [value]="nonSelectedSchedule.schedule_id">{{nonSelectedSchedule.schedule_name}}</mat-option>-->
              <!--                                    <mat-option *ngFor="let item of schedules" [value]="item.schedule_id">{{item.schedule_name}}</mat-option>-->
            <!--                                </mat-select>-->
          <!--                            </mat-form-field>-->
        </div>
      </div>

    </mat-card>
    <mat-card [ngClass]="{'active': sceneType == 'component'}" (click)="setSceneType('component')">
      <mat-card-title class="component-scene">
        <span>{{'general.componentScene' | transloco}}</span>
        <fa-icon style="float: right;" [icon]="getComponentFontIcons(typeComponent)"></fa-icon>
      </mat-card-title>
      <div class="wizard-card-body component-type" fxLayout="column" fxLayoutAlign="space-around center">
        <mat-form-field>
          <mat-select [(value)]="typeComponent" (selectionChange)="onChangeTypeSelection()">
            <mat-option value="playlist">{{'general.playlist' | transloco}}</mat-option>
            <mat-option value="collection">{{'general.collection' | transloco}}</mat-option>
            <mat-option value="scheduler">{{'general.scheduler' | transloco}}</mat-option>
          </mat-select>
          <!-- <mat-select [(value)]="typeComponent">
          <mat-option value="playlist">{{'general.playlist' | transloco}}</mat-option>
        </mat-select> -->
      </mat-form-field>

      <div class="select-playlist">
        @if (playerAssignable && typeComponent == 'scheduler') {
          <div fxLayout="column" style="width: 80%; margin: 0 auto;">
            <mat-form-field fxFlex="column">
              <mat-label>{{'general.schedulerName' | transloco}}</mat-label>
              <input inputrestriction="basic1"
                matInput required matInputAutofocus
                type="text"
                class="longInput form-control"
                placeholder=""
                [formControl]="scheduleName"
                (change)="onChnageScheduleName()">
                @if (scheduleName.invalid || scheduleName.hasError('whitespace')) {
                  <mat-error>please enter a valid name</mat-error>
                }
              </mat-form-field>
              <mat-form-field class="full-width textarea">
                <mat-label>{{'placeholder.description' | transloco}}</mat-label>
                <textarea rows="3" matInput [(ngModel)]="scheduleDesc"
                  appearance="fill"
                  inputrestriction="basic1"
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="3"></textarea>
              </mat-form-field>
            </div>
          }

          @if (playerAssignable && typeComponent != 'scheduler') {
            <div style="margin-bottom: 5px;">
              <mat-checkbox [checked]="playerAssignable" [(ngModel)]="playerAssignable">{{'general.playerAssignable' | transloco}}</mat-checkbox>
            </div>
          }
        </div>
      </div>

    </mat-card>
    <mat-card [ngClass]="{'active': sceneType == 'category'}" (click)="setSceneType('category')">
      <mat-card-title>
        <span>{{'general.specializedScene' | transloco}}</span>
        @if (upgradable) {
          <button (click)="upgrade()" routerLinkActive="active" style="position:relative; top: -2px"
            mat-button color="warn">[{{'navigation.fullAccess' | transloco}}]
          </button>
        }

      </mat-card-title>
      <div class="wizard-card-body" style="margin-top: 10px;">
        <mat-form-field>
          <mat-label>{{'placeholder.filterList' | transloco}}</mat-label>
          <input inputrestriction="basic1" matInput type="text" (keyup)="applyFilter($event.target['value'])" class="form-control" [value]="filter"
            autocomplete="off"/>
            <a matSuffix aria-label="Clear" (click)="applyFilter('')">
              <mat-icon>close</mat-icon>
            </a>
          </mat-form-field>
          <mat-radio-group class="category-radio-group" [(ngModel)]="typeCategory">
            @for (jsonType of filteredJsonTypes; track jsonType) {
              <mat-radio-button [value]="jsonType" class="category-radio-button cutText"
                [ngStyle]="{'opacity': !user.enterprise && jsonType.enterprise ? 0.7 : 1}"
                [disabled]="!user.enterprise && jsonType.enterprise">
                <fa-icon class="faCogs" [icon]="jsonType.icon"></fa-icon>
                <!--  {{'general.' + jsonType.label | transloco | StringJSV2Pipe:stringJSPipeArgs}} -->
                {{'mimes.' + jsonType.label | transloco}}
                @if (!user.enterprise && jsonType.enterprise) {
                  <span style="font-size: 0.8em">(upgrade)</span>
                }
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </mat-card>
    </div>
    <br/>
    @if (upgradable) {
      <button color="warn" mat-raised-button (click)="upgrade()">
        <mat-icon>rocket_launch</mat-icon>
        {{'general.upgradeToEnterprise' | transloco}}
      </button>
    }
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>{{'general.dimensions' | transloco}}</ng-template>
    <div class="step-body-wrapper dimensions" style="margin-left: auto; margin-right: auto;">
      <div fxLayout="row" fxFill class="contButtons">
        <button fxFlex="100%" (click)="go('0')" mat-raised-button>
          <!-- [color]="sceneStyle == 'horizontal' ? 'primary' : 'basic'" -->
          <mat-icon class="hide-lt-sm">stay_current_landscape</mat-icon>
          <span class="switchButtons">{{'general.horizontal' | transloco}}</span>
        </button>
        <button fxFlex="100%" (click)="go('1')" mat-raised-button>
          <!-- [color]="sceneStyle == 'horizontal' ? 'basic' : 'primary'" -->
          <mat-icon class="hide-lt-sm">stay_current_portrait</mat-icon>
          <span class="switchButtons ">{{'general.vertical' | transloco}}</span>
        </button>
        <button fxFlex="100%" (click)="go('2')" mat-raised-button>
          <!-- [color]="sceneStyle == 'horizontal' ? 'basic' : 'primary'" -->
          <mat-icon class="hide-lt-sm">square_foot</mat-icon>
          <span class="switchButtons ">{{'general.custom' | transloco}}</span>
        </button>
      </div>
      <ngx-flicking [options]="{ circular: false, duration: 800, autoResize: true }">
        <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="flex-lt-sm-col panel">
          <mat-icon class="dimension-icon">crop_landscape</mat-icon>
          <div>
            <mat-radio-group fxLayout="row wrap" fxLayoutGap="16px" class="dimension-radio-group" [(ngModel)]="dimensionIndex">
              @for (d of hDimensions; track d; let ind = $index) {
                <mat-radio-button class="dimension-radio-button" [value]="ind">{{d}}</mat-radio-button>
              }
              <!--                                <mat-radio-button class="dimension-radio-button" value="custom">custom</mat-radio-button>-->
            </mat-radio-group>

          </div>

        </div>
        <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="panel flex-lt-sm-col">
          <mat-icon class="dimension-icon">crop_portrait</mat-icon>
          <div>
            <mat-radio-group fxLayout="row wrap" fxLayoutGap="16px" class="dimension-radio-group" [(ngModel)]="dimensionIndex">
              @for (d of vDimensions; track d; let ind = $index) {
                <mat-radio-button class="dimension-radio-button" [value]="ind">{{d}}</mat-radio-button>
              }
              <!--                                <mat-radio-button class="dimension-radio-button" value="custom">custom</mat-radio-button>-->
            </mat-radio-group>
          </div>
        </div>

        <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="flex-lt-sm-col panel">
          <mat-icon class="dimension-icon">square_foot</mat-icon>
          <div class="dimension-radio-group">
            <mat-form-field class="custom-size-field">
              <mat-label>{{'general.width' | transloco}}</mat-label>
              <input inputrestriction="basic1" matInput type="number" max="7680" placeholder=""
                [(ngModel)]="customSizeX" autocomplete="off">
              </mat-form-field>
              <mat-form-field class="custom-size-field">
                <mat-label>{{'general.height' | transloco}}</mat-label>
                <input inputrestriction="basic1" matInput type="number" max="7680" placeholder=""
                  [(ngModel)]="customSizeY" autocomplete="off">
                </mat-form-field>
              </div>
            </div>
          </ngx-flicking>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'general.content' | transloco}}</ng-template>
        <div fxLayout="row wrap" fxLayoutAlign="center center" class="step-body-wrapper">
          @if (sceneType != 'blank') {
            @for (item of sceneContents[sceneType]; track item; let ind = $index) {
              <div class="template-scene"
                [ngClass]="{'selected': ind == templateIndex, 'horizontal': tabIndex == 0}"
                (click)="setTemplate(ind)">
                @for (coord of item; track coord) {
<div class="pattern" [ngStyle]="{
                                'top.px': coord[0],
                                'left.px': coord[1],
                                'width.px': coord[2],
                                'height.px': coord[3]
                            }">
                    @if (coord[4] == 1) {
                      <fa-icon style="font-size: 18px;" class="fa-icon1" [icon]="getComponentFontIcons(typeComponent)"></fa-icon>
                    }
                  </div>
                }
              </div>
            }
          }
          @if (sceneType == 'blank') {
            @for (item of sceneContents[sceneType]; track item; let ind = $index) {
              <img
                class="guide-image"
                [ngClass]="{'selected': ind == templateIndex, 'vertical': tabIndex == 1}"
                (click)="setTemplate(ind)"
                src="./assets/images/guidelines/{{item.src}}">
              }
            }
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{'general.player' | transloco}}</ng-template>
          <div style="position: relative;">
            <div [ngStyle]="{'opacity': (sceneType != 'category' && playerAssignable ? 1 : 0.1 )}">
              <app-station-list #appList [setLargeView]="true" [businessId]="user.businessId"></app-station-list>
            </div>
            @if (!playerAssignable || sceneType == 'category') {
              <div class="disable-wrapper" fxLayoutAlign="center center" style="padding-top: 10%; text-align: center">
                <mat-label>{{'general.skipPlayerAssign3' | transloco}}</mat-label>
                <br/>
                <br/>
                @if (selectedStep != 6) {
                  <button mat-raised-button color="warn" (click)="stepper.next()">{{'general.continue' | transloco}}</button>
                }
                <br/>
                <br/>
                <mat-icon style="font-size: 70px; width: 70px; height: 70px">block</mat-icon>
              </div>
            }
          </div>

        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{'general.animation' | transloco}}</ng-template>
          <div style="padding-left: 20px">
            <mat-radio-group fxLayout="row">
              <mat-radio-button (click)="removeAnimationSlice($event)" [checked]="!enableAnimationEngine" value="0">
                <span>{{'general.inherit' | transloco}}</span>&nbsp;&nbsp;
              </mat-radio-button>
              <mat-radio-button (click)="createAnimationSlice()" [checked]="enableAnimationEngine" value="1">
                <span>{{'general.override' | transloco}}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div style="position: relative;">
            <app-dialog-preset-animation [resetAnimations]="true" [disableUI]="!enableAnimationEngine" (selectAnimation)="presetSceneAnimation($event)"></app-dialog-preset-animation>
          </div>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>{{'general.complete' | transloco}}</ng-template>
          <div fxLayoutAlign="center center" class="step-body-wrapper" fxLayout="column" fxLayoutGap="32px">
            <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="64px" class="flex-lt-sm-col">
              <div style="min-width: 300px;">
                <table class="table-preview">
                  <tr>
                    <td class="bt-right">{{'general.sceneName' | transloco}}</td>
                    <td>{{propertyFormGroup.get('scene_name').value}}</td>
                  </tr>
                  @if (keyPath) {
                    <tr>
                      <td>{{'general.category' | transloco}}</td>
                      <td>{{keyPath}}</td>
                    </tr>
                  }
                  <tr>
                    <td>{{'general.style' | transloco}}</td>
                    <td>{{sceneStyle}}</td>
                  </tr>
                  <tr>
                    <td>{{'general.dimension' | transloco}}</td>
                    <td>
                      <div>
                        @switch (sceneStyle) {
                          @case ('vertical') {
                            <div>
                              {{vDimensions[dimensionIndex]}}
                            </div>
                          }
                          @case ('horizontal') {
                            <div>
                              {{hDimensions[dimensionIndex]}}
                            </div>
                          }
                          @case ('custom') {
                            <div>
                              {{customSizeX + ' x ' + customSizeY}}
                            </div>
                          }
                        }
                      </div>
                    </td>
                  </tr>
                  @if (sceneType == 'blank') {
                    <tr>
                      <td>{{'general.type' | transloco}}</td>
                      <td>{{'general.blank' | transloco}}</td>
                    </tr>
                  }
                  @if (sceneType == 'component') {
                    <tr>
                      <td>{{'general.type' | transloco}}</td>
                      <td>
                        <fa-icon style="font-size: 18px;" [icon]="getComponentFontIcons(typeComponent)"></fa-icon>
                        {{typeComponent}}
                      </td>
                    </tr>
                  }
                  @if (sceneType == 'category' && typeCategory) {
                    <tr>
                      <td>{{'general.type' | transloco}}</td>
                      <td>
                        <fa-icon class="faCogs" [icon]="typeCategory.icon"></fa-icon>
                        {{'general.' + typeCategory.label | transloco | StringJSV2Pipe:stringJSPipeArgs}}
                      </td>
                    </tr>
                  }
                  @if (sceneType != 'category') {
                    <tr>
                      <td>{{'general.playerAssignable' | transloco}}</td>
                      <td>{{playerAssignable}}</td>
                    </tr>
                  }
                  @if (sceneType != 'category') {
                    <tr>
                      <td>{{'general.enableScheduler' | transloco}}</td>
                      <td>{{getScheduleName(sceneSchedule)}}</td>
                    </tr>
                  }
                </table>
                <!-- <ul style="line-height: 35px;">
                <li>{{'general.sceneName' | transloco}}: {{propertyFormGroup.get('scene_name').value}}</li>
                <li *ngIf="keyPath">{{'general.category' | transloco}}: {{keyPath}}</li>
                <li>{{'general.style' | transloco}}: {{sceneStyle}}</li>
                <li>{{'general.dimension' | transloco}}: {{sceneStyle == 'horizontal' ? hDimensions[dimensionIndex]: vDimensions[dimensionIndex] }}</li>
                <li *ngIf="sceneType == 'blank'">
                  {{'general.type' | transloco}}: {{'general.blank' | transloco}}
                </li>
                <li *ngIf="sceneType == 'component'">{{'general.type' | transloco}}:&nbsp;&nbsp;
                  <fa-icon style="font-size: 18px;" [icon]="getComponentFontIcons(typeComponent)"></fa-icon>
                  {{typeComponent}}
                </li>
                <li *ngIf="sceneType == 'category' && typeCategory">{{'general.type' | transloco}}:&nbsp;&nbsp;
                  <fa-icon class="faCogs" [icon]="typeCategory.icon"></fa-icon>
                  {{'general.' + typeCategory.label | transloco | StringJSV2Pipe:stringJSPipeArgs}}
                </li>
                <ng-container *ngIf="sceneType != 'category'">
                  <li>{{'general.playerAssignable' | transloco}}: {{playerAssignable}}</li>
                  <li>{{'general.enableScheduler' | transloco}}: {{getScheduleName(sceneSchedule)}}</li>
                </ng-container>
              </ul> -->
            </div>
            @if (sceneType == 'blank') {
              <div>
                <img class="guide-image" [ngClass]="{'vertical': tabIndex == 1}"
                  src="./assets/images/guidelines/{{sceneContents[sceneType][templateIndex].src}}">
                </div>
              }
              @if (sceneType != 'blank') {
                <div>
                  <div class="template-scene" [ngClass]="{'horizontal': tabIndex == 0}">
                    @for (coord of sceneContents[sceneType][templateIndex]; track coord) {
<div class="pattern" [ngStyle]="{
                                    'top.px': coord[0],
                                    'left.px': coord[1],
                                    'width.px': coord[2],
                                    'height.px': coord[3]
                                }">
                        @if (coord[4] == 1) {
                          <fa-icon style="font-size: 18px;" class="fa-icon1" [icon]="getComponentFontIcons(typeComponent)"></fa-icon>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <button mat-raised-button color="warn" (click)="createScene()">{{'general.newScene' | transloco}}</button>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </div>


